import { Modal } from "bootstrap";

export default class DownloadModal {
  constructor(node) {
    this.element = node;

    this.downloadButton = this.element.querySelector(".js-download-button");
    this.checkboxInput = this.element.querySelector(".js-download-checkbox");
    this.downloadLink = this.element.querySelector(".js-download-link");

    this.modalInstance = Modal.getInstance(this.element);

    this.initialize();
  }

  initialize() {
    this.checkboxInput.addEventListener("change", (e) => {
      if (e.target.checked) {
        this.downloadButton.removeAttribute("disabled");
      } else {
        this.downloadButton.setAttribute("disabled", "disabled");
      }
    });

    this.downloadButton.addEventListener("click", () => {
      this.downloadLink.click();
      this.modalInstance.hide();
    });
  }
}
